import backSvg from "@/assets/shared/back.svg";
import logoSvg from "@/assets/shared/logo.svg";

type NavHeaderProps = {
  logo?: string;
};

export const NavHeader = ({ logo }: NavHeaderProps) => (
  <nav className="nav-header">
    <div className="nav-content">
      <button className="nav-back-btn">
        <img src={backSvg} alt="Back" />
      </button>
      <div className="nav-logo">
        <img src={logo || logoSvg} alt="Logo" className="logo-svg" />
      </div>
      <div className="nav-spacer"></div>
    </div>
  </nav>
);
